import React from 'react'
import { homeObjectThree } from '../Data'
import { InfoSection } from '../components'

const Work = () => {
  return (
    <>
    <InfoSection {...homeObjectThree} />
   </>
  )
}

export default Work